import { SpinnerCircular, Typography } from '@repo/ui';
import c from 'classnames';
import KitVersionUpdateTooltip from 'components/KitVersionUpdateTooltip/KitVersionUpdateTooltip';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import styles from './VersionPill.module.scss';

type Props = {
  shadow?: boolean;
};

function UpdatingStatus() {
  return (
    <>
      <SpinnerCircular size={16} />
      <Typography variant='label'>Updating...</Typography>
    </>
  );
}

const VersionPill = ({ shadow = false }: Props) => {
  const { isUpdating, prettyVersion, hasOutdatedKitVersion } =
    useKitSystemInfo();

  if (!isUpdating && !prettyVersion) return null;

  return (
    <div className={c(styles.versionPill, shadow && styles.shadow)}>
      {isUpdating ? (
        <UpdatingStatus />
      ) : (
        <KitVersionUpdateTooltip>
          <div
            className={c(styles.dot, hasOutdatedKitVersion && styles.outdated)}
          />
          <Typography variant='label' className={styles.versionText}>
            {prettyVersion}
          </Typography>
        </KitVersionUpdateTooltip>
      )}
    </div>
  );
};
export default VersionPill;
